var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#da121a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v10H0V7.5Z",
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v5H0v-5Z",
    style: {
      fill: "#078930"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5,
    style: {
      fill: "#0f47af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,11l-.175.539.723,2.225h-.964l-.108.333h3.09l.459-.333h-2.126l-.899-2.764Z",
    style: {
      fill: "#fcdd09"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.078,13.517l1.274-1.753"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.642,
    y: 12.535,
    width: 2.167,
    height: 0.167,
    transform: "translate(-3.314 18.733) rotate(-53.999)",
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.804,13.764h-.567l-1.892,1.375-.298-.917h-.35l.955,2.939.459.333-.657-2.022,2.35-1.708Z",
    style: {
      fill: "#fcdd09"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.744,15.567l2.061.669"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.712,
    y: 14.82,
    width: 0.167,
    height: 2.167,
    transform: "translate(-2.828 27.914) rotate(-72.002)",
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.351,18.236l-.175-.539-1.892-1.375.78-.567-.108-.333-2.5,1.816-.175.539,1.72-1.25,2.35,1.709Z",
    style: {
      fill: "#fcdd09"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15,16.833v2.167"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.917,
    y: 16.833,
    width: 0.167,
    height: 2.167,
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.649,18.236l.459-.333.723-2.225.78.566.284-.206-2.5-1.816h-.567l1.72,1.25-.899,2.764Z",
    style: {
      fill: "#fcdd09"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.256,15.567l-2.061.67"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.143,
    y: 15.8,
    width: 2.167,
    height: 0.167,
    transform: "translate(-4.311 4.557) rotate(-18.006)",
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.196,13.764l.459.333h2.339l-.298.917.284.206.955-2.939-.175-.539-.657,2.022h-2.907Z",
    style: {
      fill: "#fcdd09"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.922,13.517l-1.274-1.753"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.205,
    y: 11.551,
    width: 0.167,
    height: 2.167,
    transform: "translate(-4.889 10.224) rotate(-36.001)",
    style: {
      fill: "#fcdd09"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/ET.9639f8f45d4825878f12dcff5d4646da.svg";
export { ForwardRef as ReactComponent };